import { ChevronRight } from '@mui/icons-material';
import { SIDENAV_TOKENS } from '../sidenav-tokens';

type NavItemExpandChevronProps = {
  expanded: boolean;
};

/**
 * Subtle expand hint for parent nav items.
 * Uses one right chevron and rotates it down when the submenu is open.
 */
export function NavItemExpandChevron({ expanded }: NavItemExpandChevronProps) {
  return (
    <ChevronRight
      sx={{
        fontSize: SIDENAV_TOKENS.iconSize,
        opacity: 0.55,
        flexShrink: 0,
        ml: 1,
        transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
        transition: 'transform 0.2s ease-in-out',
      }}
    />
  );
}
